import { Box, Button, Chip, Grid, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import axios from 'axios';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { ConfirmDialog, FaqBox, FormTitle } from 'components';
import { updateRequest } from 'services';
import { renderRowCreatedAt } from 'utils/renderTableCell';
import { useSnackbar } from 'notistack';
import { activatedRequest, deactivatedRequest } from 'services/requests/update';
import { getMedia } from 'utils/getImage';
import { CVThemesMockData } from 'mocks/themesMockData';
import { rejectUpdateRequest } from 'services/requests/rejectUpdate';
import { acceptUpdateRequest } from 'services/requests/acceptUpdate';
import { useSearchParams } from 'react-router-dom';

const INITIAL_STATE = {
  user: '',
  createdAt: '',
  host: '',
  theme: 1,
  image: null,
  address: '',
  about: '',
  phone: '',
  cv: '',
  title: '',
  type: '',
};

const CommunicateWaysData = [
  {
    title: 'ایمیل',
    key: 'email',
    icon: 'sms',
    renderValue: (support) => support?.emails?.[0] || 'خالی می باشد.',
  },
  {
    title: 'شماره همراه',
    key: '0',
    icon: 'mobile',
    renderValue: (support) => support?.phones?.[0] || 'خالی می باشد.',
  },
  {
    title: 'تلگرام',
    key: 'telegram',
    icon: 'telegram',
    renderValue: (support) => support?.telegramAccounts?.[0] || 'خالی می باشد.',
  },
  {
    title: 'واتساپ',
    key: 'whatsApp',
    icon: 'whatsapp',
    renderValue: (support) => support?.whatsappAccounts?.[0] || 'خالی می باشد.',
  },
  {
    title: 'اینستاگرام',
    key: 'instagram',
    icon: 'instagram',
    renderValue: (support) => support?.instagramAccounts?.[0] || 'خالی می باشد.',
  },
  {
    title: 'فیسبوک',
    key: 'facebook',
    icon: 'facebook',
    renderValue: (support) => support?.facebookAccounts?.[0] || 'خالی می باشد.',
  },
  {
    title: 'لینکدین',
    key: 'linkedin',
    icon: 'linkdin',
    renderValue: (support) => support?.linkedInAccounts?.[0] || 'خالی می باشد.',
  },
];

const SliderItem = ({ title, url, mediaHash }) => (
  <Stack
    direction={'row'}
    sx={{ background: '#F4F4F4', borderRadius: '15px', overflow: 'hidden', wordBreak: 'break-all' }}
    p={1}
    alignItems={'center'}
    gap={1}
    justifyContent={'flex-start'}
  >
    <img
      aria-hidden
      src={getMedia(mediaHash)}
      alt=""
      onClick={() => window?.open(getMedia(mediaHash), '_blank')}
      style={{ width: '140px', height: '100px', borderRadius: '15px', objectFit: 'cover', cursor: 'pointer' }}
    />
    <Stack>
      <Typography color={'#222'} fontWeight={700}>
        {title}
      </Typography>
      <Typography color={'#222'} fontWeight={700}>
        <a target="_blank" rel="noreferrer" href={url}>
          لینک اسلایدر
        </a>
      </Typography>
    </Stack>
  </Stack>
);

export const CvDetailForm = () => {
  const [collapseState, _setCollapseState] = useState({
    siteInfo: true,
    information: true,
    userSite: true,
    banner: true,
    slider: true,
    imageGallery: true,
    location: true,
    video: true,
    profile_image: true,
    cover_image: true,

    about_us: true,
    communicate_ways: true,
    siteTitle: true,
    siteSubTitle: true,
  });
  const { enqueueSnackbar } = useSnackbar();
  const [state, setState] = useState({});
  const [updateRequestData, setUpdateRequestsData] = useState([]);

  const profileRef = useRef();
  const navigate = useNavigate();
  const [request, setRequest] = useState(INITIAL_STATE);
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const isUpdateMode = searchParams.get('update') === '1';

  const [productCategories, setProductCategories] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [categoryListCount, setCategoryListCount] = useState(0);
  const [allCategories, setAllCategories] = useState(false);
  const [open, setOpen] = useState(false);
  const [updateID, setUpdateID] = useState(null);
  const [rejectModalState, setRejectModalState] = useState(false);
  const [updateRequests, setUpdateRequests] = useState([]);
  const [rejected, setRejected] = useState({
    site: state?._id,
    reason: '',
    description: '',
    notifyUser: false,
  });

  const [hostCheck, setHostCheck] = useState({
    ok: false,
    loading: false,
    checked: request?.host !== state?.host,
  });

  const setCollapseState = (key, value) => {
    _setCollapseState({
      ...collapseState,
      [key]: value,
    });
  };

  const getCategoryList = useCallback(async () => {
    try {
      const response = await axios.get('/admin/category/list');
      const { categories } = response.data;
      setCategoryListCount(response.data.categories.length);
      setCategoryList(categories);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const onAcceptRequest = async () => {
    try {
      // await updateRequest(request, state?._id, productCategories);
      // console.log(request);
      await updateRequest(request, state?._id, productCategories, allCategories);
      if (state.status !== 3) {
        await activatedRequest(state?._id);
      }
      enqueueSnackbar('با موفقیت ثبت شد', { variant: 'success' });
      navigate('/dashboard/request/new-request');
    } catch (error) {}
  };
  const onRejectRequest = async () => {
    try {
      await deactivatedRequest({ ...rejected, site: id });
      enqueueSnackbar('با موفقیت انجام شد', { variant: 'success' });
      navigate('/dashboard/request/new-request');
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCategoryList();
  }, [getCategoryList]);

  useEffect(() => {
    if (isUpdateMode) {
      axios
        .get(`/admin/site/update/list`, {
          params: {
            site: id,
            page: 1,
            limit: 10,
          },
        })
        .then((res) => {
          setUpdateRequests(res?.data?.data?.[0]?.updateRequests);
          setState({ ...res?.data?.data?.[0]?.site, config: res?.data?.data?.[0]?.siteConfig });
        });
    } else {
      axios
        .get(`/admin/site/search`, {
          params: {
            _id: id,
            page: 1,
            limit: 10,
          },
        })
        .then((res) => {
          setState(res.data?.data?.[0]);
        });
    }
  }, [id, isUpdateMode]);

  useEffect(() => {
    setRequest({
      ...state,
      user: state?.user?._id,
      createdAt: state?.createdAt,
      host: state?.host,
      about: state?.config?.about?.data,
      phone: state?.config?.support?.phones?.[0],
      address: state?.config?.address?.plain,
      cv: state?.config?.cv?.data,
      theme: state?.config?.theme,
      title: state?.title,
      avatar: state?.config?.avatar,
      type: state.type,
    });
  }, [state, productCategories?.length, categoryList]);

  const onRejectUpdate = (update) => {
    setUpdateID(update?._id);
    const index = updateRequestData?.findIndex((el) => el?.update === update?._id);

    if (index === -1) {
      setUpdateRequestsData([
        ...updateRequestData,
        {
          update: update?._id,
          reason: '',
          description: '',
          notifyUser: false,
          isApproved: null,
        },
      ]);
    }
    setRejectModalState(true);
  };

  const onApproveUpdate = async (update) => {
    try {
      await acceptUpdateRequest({
        updateID: update?._id,
      });
      enqueueSnackbar('با موفقیت انجام شد', { variant: 'success' });
      const index = updateRequestData?.findIndex((el) => el?.update === update?._id);
      if (index === -1) {
        setUpdateRequestsData([
          ...updateRequestData,
          {
            update: update?._id,
            reason: '',
            description: '',
            notifyUser: false,
            isApproved: true,
          },
        ]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onRejectUpdateRequest = async () => {
    try {
      const copy = JSON.parse(JSON.stringify(updateRequestData));
      const index = updateRequestData?.findIndex((el) => el?.update === updateID);
      copy[index] = {
        ...copy[index],
        isApproved: false,
      };

      setUpdateRequestsData(copy);
      await rejectUpdateRequest({
        updateID,
        reason: copy[index]?.reason,
        description: copy[index]?.description,
        notifyUser: copy[index]?.notifyUser,
      });
      // await deactivatedRequest(rejected);
      enqueueSnackbar('با موفقیت انجام شد', { variant: 'success' });
      setRejectModalState(false);
      // navigate(-1);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const payload = {
      ...state,
    };
    try {
      updateRequests?.forEach((req) => {
        if (req?.usage === 'faq') {
          payload.config.faq = req?.newValue?.faq;
        }

        if (req?.usage === 'about') {
          payload.config.about = req?.newValue?.about;
        }

        if (req?.usage === 'linkedSites') {
          payload.config.linkedSites = req?.newValue?.linkedSites;
        }

        if (req?.usage === 'supportNoAddress') {
          payload.config.support = req?.newValue?.support;
        }

        if (req?.usage === 'title') {
          payload.title = req?.newValue?.title;
        }

        if (req?.usage === 'subtitle') {
          payload.config.subtitle = req?.newValue?.subtitle;
        }

        if (req?.usage === 'cover') {
          payload.config.cover = req?.newValue;
        }

        if (req?.usage === 'avatar') {
          payload.config.avatar = req?.newValue;
        }

        if (req?.usage === 'banners') {
          payload.config.banners = req?.newValue?.banners;
        }

        if (req?.usage === 'sliders') {
          payload.config.sliders = req?.newValue?.sliders;
        }

        if (req?.usage === 'videos') {
          payload.config.videos = req?.newValue?.videos;
        }

        if (req?.usage === 'gallery') {
          payload.config.gallery = req?.newValue?.gallery;
        }

        if (req?.usage === 'address') {
          payload.config.address = req?.newValue?.address;
        }
      });
      setRequest(payload);
    } catch (error) {}
  }, [updateRequests, state]);

  const aboutUpdate = updateRequests?.find((el) => el?.usage === 'about');
  const avatarUpdate = updateRequests?.find((el) => el?.usage === 'avatar');
  const coverUpdate = updateRequests?.find((el) => el?.usage === 'cover');
  const supportNoAddressUpdate = updateRequests?.find((el) => el?.usage === 'supportNoAddress');
  const linkedSitesUpdate = updateRequests?.find((el) => el?.usage === 'linkedSites');
  const addressUpdate = updateRequests?.find((el) => el?.usage === 'address');
  const faqUpdate = updateRequests?.find((el) => el?.usage === 'faq');
  const titleUpdate = updateRequests?.find((el) => el?.usage === 'title');
  const subtitleUpdate = updateRequests?.find((el) => el?.usage === 'subtitle');
  const bannersUpdate = updateRequests?.find((el) => el?.usage === 'banners');
  const slidersUpdate = updateRequests?.find((el) => el?.usage === 'sliders');
  const videosUpdate = updateRequests?.find((el) => el?.usage === 'videos');
  const galleryUpdate = updateRequests?.find((el) => el?.usage === 'gallery');

  return (
    <>
      {request?._id && (
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <TextField
              label="نام کاربری"
              fullWidth
              disabled
              value={request.userID}
              onChange={(e) => setRequest({ ...request, user: e.target.value })}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField label="تاریخ درخواست" fullWidth value={renderRowCreatedAt('fa-IR', state?.createdAt)} />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="آدرس دامنه"
              fullWidth
              value={request.host}
              onChange={(e) => {
                // setHostCheck({ ...hostCheck, checked: false });
                // setRequest({ ...request, host: e.target.value });
              }}
              InputProps={{
                endAdornment: request.host !== state?.host && (
                  <InputAdornment position="end">
                    {hostCheck.checked ? (
                      hostCheck.ok ? (
                        <Chip label="صحیح" variant="filled" sx={{ bgcolor: '#1DB954', color: '#fff' }} />
                      ) : (
                        <Chip label="نادرست" variant="filled" sx={{ bgcolor: '#E50450', color: '#fff' }} />
                      )
                    ) : (
                      <></>
                    )}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label={'تم انتخابی'}
              value={CVThemesMockData?.find((el) => el?.id === request?.config?.theme)?.title}
            />
          </Grid>
          <FormTitle
            icon="information"
            label="عنوان سایت"
            has_collapse
            collapseState={collapseState?.siteTitle}
            onCollapseChange={() => setCollapseState('siteTitle', !collapseState?.siteTitle)}
            needApprove={titleUpdate !== undefined}
            onApprove={() => onApproveUpdate(titleUpdate)}
            isApproved={updateRequestData?.find((el) => el?.update === titleUpdate?._id)?.isApproved}
            onReject={() => onRejectUpdate(titleUpdate)}
          />
          {collapseState?.siteTitle && (
            <>
              <Grid item xs={12}>
                <TextField label="عنوان سایت" fullWidth value={request?.title} />
              </Grid>
            </>
          )}

          <FormTitle
            icon="information"
            label="زیرعنوان سایت"
            has_collapse
            collapseState={collapseState?.siteSubTitle}
            onCollapseChange={() => setCollapseState('siteSubTitle', !collapseState?.siteSubTitle)}
            needApprove={subtitleUpdate !== undefined}
            onApprove={() => onApproveUpdate(subtitleUpdate)}
            isApproved={updateRequestData?.find((el) => el?.update === subtitleUpdate?._id)?.isApproved}
            onReject={() => onRejectUpdate(subtitleUpdate)}
          />
          {collapseState?.siteSubTitle && (
            <>
              <Grid item xs={12}>
                <TextField
                  label="عنوان شغلی یا زیر عنوان وبسایت"
                  value={request?.config?.subtitle}
                  fullWidth
                  readOnly
                />
              </Grid>
            </>
          )}
          <FormTitle
            icon="profile_icon"
            label="تصویر شخصی"
            has_collapse
            collapseState={collapseState?.profile_image}
            onCollapseChange={() => setCollapseState('profile_image', !collapseState?.profile_image)}
            needApprove={avatarUpdate !== undefined}
            onApprove={() => onApproveUpdate(avatarUpdate)}
            isApproved={updateRequestData?.find((el) => el?.update === avatarUpdate?._id)?.isApproved}
            onReject={() => onRejectUpdate(avatarUpdate)}
          />
          {collapseState?.profile_image && (
            <>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-end',
                    gap: '1rem',
                    margin: '1rem 0',
                  }}
                >
                  <img
                    src={getMedia(request?.config?.avatar?.hash)}
                    alt="avatar"
                    style={{
                      width: '160px',
                      height: '160px',
                      borderRadius: '20px',
                      boxShadow: '0px 12px 22px rgba(0, 0, 0, 0.09)',
                      cursor: 'pointer',
                    }}
                    aria-hidden
                    onClick={(e) => {
                      profileRef.current.click();
                      e.target.value = null;
                      window?.open(getMedia(request?.config?.avatar?.hash), '_blank');
                    }}
                  />
                  <input hidden type="file" ref={profileRef} accept="image/*" readOnly disabled />
                </Box>
              </Grid>
            </>
          )}

          <FormTitle
            icon="profile_icon"
            label="تصویر پشت"
            has_collapse
            collapseState={collapseState?.cover_image}
            onCollapseChange={() => setCollapseState('cover_image', !collapseState?.cover_image)}
            needApprove={coverUpdate !== undefined}
            onApprove={() => onApproveUpdate(coverUpdate)}
            isApproved={updateRequestData?.find((el) => el?.update === coverUpdate?._id)?.isApproved}
            onReject={() => onRejectUpdate(coverUpdate)}
          />
          {collapseState?.cover_image && (
            <>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-end',
                    gap: '1rem',
                    margin: '1rem 0',
                  }}
                >
                  <img
                    src={getMedia(request?.config?.cover?.hash)}
                    alt="avatar"
                    aria-hidden
                    style={{
                      width: '550px',
                      height: '150px',
                      borderRadius: '20px',
                      objectPosition: 'center',
                      objectFit: 'cover',
                      boxShadow: '0px 12px 22px rgba(0, 0, 0, 0.09)',
                      cursor: 'pointer',
                    }}
                    onClick={(e) => {
                      profileRef.current.click();
                      e.target.value = null;
                      window?.open(getMedia(request?.config?.cover?.hash), '_blank');
                    }}
                  />
                  <input hidden type="file" ref={profileRef} accept="image/*" readOnly disabled />
                </Box>
              </Grid>
            </>
          )}
          <FormTitle
            icon="text"
            label="درباره ما"
            has_collapse
            collapseState={collapseState?.about_us}
            onCollapseChange={() => setCollapseState('about_us', !collapseState?.about_us)}
            needApprove={aboutUpdate !== undefined}
            onApprove={() => onApproveUpdate(aboutUpdate)}
            isApproved={updateRequestData?.find((el) => el?.update === aboutUpdate?._id)?.isApproved}
            onReject={() => onRejectUpdate(aboutUpdate)}
          />
          {collapseState?.about_us && (
            <Grid item xs={12}>
              <Stack direction={'column'} gap={2}>
                <TextField label="عنوان بخش" value={request?.config?.about?.title} fullWidth readOnly />
                <TextField minRows={4} multiline fullWidth mt={2} value={request?.config?.about?.data} />
              </Stack>
            </Grid>
          )}
          <FormTitle
            icon="headphone"
            label="راه های ارتباطی"
            has_collapse
            collapseState={collapseState?.communicate_ways}
            onCollapseChange={() => setCollapseState('communicate_ways', !collapseState?.communicate_ways)}
            needApprove={supportNoAddressUpdate !== undefined}
            onApprove={() => onApproveUpdate(supportNoAddressUpdate)}
            isApproved={updateRequestData?.find((el) => el?.update === supportNoAddressUpdate?._id)?.isApproved}
            onReject={() => onRejectUpdate(supportNoAddressUpdate)}
          />
          {collapseState?.communicate_ways && (
            <>
              {CommunicateWaysData?.map((c_item, index) => (
                <Grid key={`${c_item?.key}-${index}`} item xs={12} md={4} lg={3} xl={3}>
                  <Stack
                    bgcolor={'#F4F4F4'}
                    alignItems={'center'}
                    direction={'row'}
                    gap={1}
                    py={1.5}
                    px={2}
                    borderRadius={1}
                  >
                    <img src={`/icons/${c_item?.icon}.svg`} width={30} height={30} alt="" />
                    <Stack direction={'column'} gap={1}>
                      <Typography color={'#475466'} fontWeight={700} fontSize={14}>
                        {c_item?.title}
                      </Typography>
                      <Typography color={'#475466'} fontWeight={600} fontSize={12}>
                        {c_item?.renderValue(request?.config?.support)}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              ))}
            </>
          )}
          <FormTitle
            icon="location"
            label="موقعیت مکانی"
            has_collapse
            collapseState={collapseState?.location}
            onCollapseChange={() => setCollapseState('location', !collapseState?.location)}
            needApprove={addressUpdate !== undefined}
            onApprove={() => onApproveUpdate(addressUpdate)}
            isApproved={updateRequestData?.find((el) => el?.update === addressUpdate?._id)?.isApproved}
            onReject={() => onRejectUpdate(addressUpdate)}
          />
          {collapseState?.location && (
            <Grid item xs={12}>
              <TextField label="آدرس" value={request?.config?.address?.plain} fullWidth readOnly />
            </Grid>
          )}
          <FormTitle
            icon="global"
            label="سایت شخصی"
            has_collapse
            collapseState={collapseState?.userSite}
            onCollapseChange={() => setCollapseState('userSite', !collapseState?.userSite)}
            needApprove={linkedSitesUpdate !== undefined}
            onApprove={() => onApproveUpdate(linkedSitesUpdate)}
            isApproved={updateRequestData?.find((el) => el?.update === linkedSitesUpdate?._id)?.isApproved}
            onReject={() => onRejectUpdate(linkedSitesUpdate)}
          />
          {collapseState?.userSite && (
            <Grid item xs={12}>
              <TextField label="لینک سایت " fullWidth value={request?.config?.linkedSites?.[0]?.url} />
              <Typography my={2} fontWeight={600} color="#475466">
                رنگ بخش
              </Typography>
              <div
                style={{
                  background: '#fff',
                  border: '1px solid #ddd',
                  borderRadius: '20px',
                  width: '70px',
                  height: '60px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <div
                  style={{
                    background: '#fff',
                    border: `1px solid ${request?.config?.linkedSites?.[0]?.color || '#712EFF'}`,
                    borderRadius: '20px',
                    width: '35px',
                    height: '35px',
                    padding: '3px',
                  }}
                >
                  <div
                    style={{
                      background: request?.config?.linkedSites?.[0]?.color || '#712EFF',

                      borderRadius: '50%',
                      width: '100%',
                      height: '100%',
                    }}
                  />
                </div>
              </div>
              <Typography fontSize={'14px'} my={1}>
                رنگ دکمه این بخش می باشد
              </Typography>
            </Grid>
          )}
          <FormTitle
            icon="photo"
            label="ویدئو"
            has_collapse
            collapseState={collapseState?.video}
            onCollapseChange={() => setCollapseState('video', !collapseState?.video)}
            needApprove={videosUpdate !== undefined}
            onApprove={() => onApproveUpdate(videosUpdate)}
            isApproved={updateRequestData?.find((el) => el?.update === videosUpdate?._id)?.isApproved}
            onReject={() => onRejectUpdate(videosUpdate)}
          />
          {collapseState?.video && (
            <Grid item xs={12}>
              <TextField label="عنوان ویدئو" value={request?.config?.videos?.[0]?.caption} fullWidth readOnly />
              {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
              <video
                width="380"
                height="240"
                style={{ margin: '20px 0px' }}
                src={
                  request?.config?.videos?.[0]?.file?.hash
                    ? getMedia(request?.config?.videos?.[0]?.file?.hash)
                    : undefined
                }
                controls
              />
              {/* <video width="320" height="240" controls>
                <source src={getMedia(request?.config?.videos?.[0]?.file?.hash)} type="video/mp4" />
                Your browser does not support the video tag.
              </video> */}
            </Grid>
          )}
          <FormTitle
            icon="photo"
            label="بنر"
            has_collapse
            collapseState={collapseState?.banner}
            onCollapseChange={() => setCollapseState('banner', !collapseState?.banner)}
            needApprove={bannersUpdate !== undefined}
            onApprove={() => onApproveUpdate(bannersUpdate)}
            isApproved={updateRequestData?.find((el) => el?.update === bannersUpdate?._id)?.isApproved}
            onReject={() => onRejectUpdate(bannersUpdate)}
          />

          {collapseState?.banner && (
            <Grid item xs={12}>
              <TextField
                label="عنوان بنر"
                value={request?.config?.banners?.[0]?.caption}
                fullWidth
                readOnly
                sx={{ my: 2 }}
              />
              <TextField
                label="لینک بنر"
                value={request?.config?.banners?.[0]?.url}
                fullWidth
                readOnly
                sx={{ my: 2 }}
              />
              <img
                width="40%"
                aria-hidden
                height="240"
                src={getMedia(request?.config?.banners?.[0]?.file?.hash)}
                onClick={() => window?.open(getMedia(request?.config?.banners?.[0]?.file?.hash), '_blank')}
                alt=""
                style={{ marginTop: '20px', borderRadius: '15px', objectFit: 'cover', cursor: 'pointer' }}
              />
              {/* <video width="320" height="240" controls>
                <source src={getMedia(request?.config?.videos?.[0]?.file?.hash)} type="video/mp4" />
                Your browser does not support the video tag.
              </video> */}
            </Grid>
          )}
          <FormTitle
            icon="photo"
            label="اسلایدر"
            has_collapse
            collapseState={collapseState?.slider}
            onCollapseChange={() => setCollapseState('slider', !collapseState?.slider)}
            needApprove={slidersUpdate !== undefined}
            onApprove={() => onApproveUpdate(slidersUpdate)}
            isApproved={updateRequestData?.find((el) => el?.update === slidersUpdate?._id)?.isApproved}
            onReject={() => onRejectUpdate(slidersUpdate)}
          />
          {collapseState?.slider && (
            <>
              {request?.config?.sliders?.map((sliderItem, index) => (
                <Grid key={index} item xs={6}>
                  <SliderItem title={sliderItem?.caption} url={sliderItem?.url} mediaHash={sliderItem?.file?.hash} />
                </Grid>
              ))}
            </>
          )}
          <FormTitle
            icon="photo"
            label="گالری عکس"
            has_collapse
            collapseState={collapseState?.imageGallery}
            onCollapseChange={() => setCollapseState('imageGallery', !collapseState?.imageGallery)}
            needApprove={galleryUpdate !== undefined}
            onApprove={() => onApproveUpdate(galleryUpdate)}
            isApproved={updateRequestData?.find((el) => el?.update === galleryUpdate?._id)?.isApproved}
            onReject={() => onRejectUpdate(galleryUpdate)}
          />
          {collapseState?.imageGallery && (
            <Grid item xs={12}>
              <Stack direction={'row'} gap={2}>
                {request?.config?.gallery?.map((img, index) => (
                  <img
                    key={index}
                    src={getMedia(img?.hash)}
                    alt="image"
                    aria-hidden
                    onClick={() => window?.open(getMedia(img?.hash), '_blank')}
                    style={{
                      width: '150px',
                      height: '150px',
                      objectFit: 'cover',
                      border: '1px solid #ddd',
                      borderRadius: '10px',
                      cursor: 'pointer',
                    }}
                  />
                ))}
              </Stack>
            </Grid>
          )}
          <FormTitle
            icon="information"
            label="سوالات متداول"
            has_collapse
            collapseState={collapseState?.information}
            onCollapseChange={() => setCollapseState('information', !collapseState?.information)}
            needApprove={faqUpdate !== undefined}
            onApprove={() => onApproveUpdate(faqUpdate)}
            isApproved={updateRequestData?.find((el) => el?.update === faqUpdate?._id)?.isApproved}
            onReject={() => onRejectUpdate(faqUpdate)}
          />
          {collapseState?.information && (
            <Grid item xs={12}>
              <Stack direction={'column'} gap={2}>
                {request?.config?.faq?.map((faqItem, index) => (
                  <FaqBox key={index} title={faqItem?.q} description={faqItem?.a} />
                ))}
              </Stack>
            </Grid>
          )}
        </Grid>
      )}

      {isUpdateMode === false && (
        <Grid item xs={12} mt={4}>
          <Stack flexDirection="row" justifyContent="flex-end" gap={1}>
            <Button
              variant="contained"
              size="large"
              sx={{
                width: 200,
                bgcolor: '#E50450',
                '&:hover': {
                  bgcolor: '#ab003a',
                },
              }}
              onClick={() => setOpen(true)}
            >
              رد درخواست
            </Button>
            <Button variant="contained" color="success" size="large" sx={{ width: 200 }} onClick={onAcceptRequest}>
              {'تایید درخواست'}
            </Button>
          </Stack>
        </Grid>
      )}

      <ConfirmDialog
        open={open}
        onClose={() => setOpen(false)}
        rejected={rejected}
        setRejected={setRejected}
        action={onRejectRequest}
      />
      <ConfirmDialog
        open={rejectModalState}
        onClose={() => setRejectModalState(false)}
        rejected={JSON.parse(JSON.stringify(updateRequestData?.find((el) => el?.update === updateID) || {}))}
        setRejected={(data) => {
          const copy = JSON.parse(JSON.stringify(updateRequestData));
          const index = copy?.findIndex((el) => el?.update === updateID);
          copy[index] = data;
          setUpdateRequestsData(copy);
        }}
        action={onRejectUpdateRequest}
      />
    </>
  );
};
